//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import LazyHydrate from 'vue-lazy-hydration';

import { helper } from '~/mixins/helper'

export default {

    name: 'Media',

    mixins: [helper],

    //components: { LazyHydrate },

    data() {
        return {
            sliderItems: [],
            slide: 0,
        }
    },

    head() {
        return {
            bodyAttrs: {
                class: ['media-wrap']
            }
        }
    },

    async asyncData({ $xhrHelper, $logger }) {

/*        if (process.client) {
            window.$nuxt.$loading.start()
        }*/

        //let resource = await $xhrHelper.getResourceById('media-slider')

        let sliderItems = []

        try{
            const resource = await $xhrHelper.getResourceById('media-slider')
            sliderItems = resource.news
        } catch (e) {
            $logger.captureExceptionAxios(e, true)
        }

        return { sliderItems: sliderItems }


/*        const response = await $axios.$get($ziggy.route('api.media.slider', undefined, false))
        return { sliderItems: response.news }*/

/*        if (process.client) {
            window.$nuxt.$loading.finish()
        }*/

    },

    /*async fetch() {

        const response = await this.$http.$get(this.route('api.media.slider'))

        this.sliderItems = response.news;
    },*/


    destroyed() {
        this.$store.commit('media/category', false)
    },

    methods: {

        setViewType: function(viewType) {
            this.$store.commit('media/setNewsView', viewType)
        },

    },

    computed: {

        category() {
            return this.$store.state.media.category
        },

        viewType: function () {
            return this.$store.state.media.newsView
        },

        viewTypeGrid: function () {
            return this.viewType === 'grid'
        },

        viewTypeList: function () {
            return this.viewType === 'list'
        },

    }

}

